import DateUtils from 'utils/Date';

const formatPurchaseDate = dateString => {
    if (!dateString) {
        return null;
    }

    const parts = dateString.split('/');

    if (parts.length !== 3) {
        return null;
    }

    const month = parseInt(parts[0], 10);
    const day = parseInt(parts[1], 10);

    if (isNaN(month) || isNaN(day) || month < 1 || month > 12) {
        return null;
    }

    const date = new Date(parts[2], month - 1, day);

    return DateUtils.getDateInMMDD(date).toUpperCase();
};

const hasPurchaseDate = product => Boolean(product?.last_purchase_date);

const getPurchasedAttributes = (product, localization) => {
    const attributes = [];

    if (product.color) {
        attributes.push(`${localization.color} ${product.color}`);
    }

    if (product.shade) {
        attributes.push(`${localization.shade} ${product.shade}`);
    }

    if (product.variant) {
        attributes.push(`${localization.variant} ${product.variant}`);
    }

    return attributes;
};

export {
    formatPurchaseDate, hasPurchaseDate, getPurchasedAttributes
};
